import { useController, type UseControllerReturn, type FieldPath } from 'react-hook-form';

export type FilterFormSchema<T> = {
  filters: Record<string, T>;
};

type UseFilterControllerProps<T = string> = {
  name: string;
  defaultValue?: T;
};

export type UseFilterControllerReturn<T> = Omit<
  UseControllerReturn<FilterFormSchema<T>, FieldPath<FilterFormSchema<T>>>,
  'field'
> & {
  field: Omit<
    UseControllerReturn<FilterFormSchema<T>, FieldPath<FilterFormSchema<T>>>['field'],
    'value' | 'onChange'
  > & {
    value: T;
    onChange: (value: T) => void;
  };
};

export const useFilterController = <T = string>({
  name,
  defaultValue,
}: UseFilterControllerProps<T>): UseFilterControllerReturn<T> =>
  useController<FilterFormSchema<T>, FieldPath<FilterFormSchema<T>>>({
    name: `filters.${name}` as FieldPath<FilterFormSchema<T>>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // biome-ignore lint/suspicious/noExplicitAny: cannot cast to correct value
    defaultValue: defaultValue as any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // biome-ignore lint/suspicious/noExplicitAny: cannot cast to correct value
  }) as any;

export const tableFilterName = (name: string) => `filters.${name}`;
